import React from 'react';
import './App.css';
import { ApolloClient, HttpLink, InMemoryCache } from 'apollo-boost';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Page, Header, Footer, Posts, PostDetail } from './views';

const client = new ApolloClient(
  {
    link: new HttpLink(
      { uri: 'https://ochremedia.com/wp/graphql' }),
    cache: new InMemoryCache(),
  }
);

function App() {
  return (
    <ApolloProvider client={client}>
      <BrowserRouter>
        <div className="content">
          <Header />
          
            <Routes>
              <Route path="/" element={<Posts />} />
              <Route path="/about" element={<Page />} />
              <Route path="/contact" element={<Page />} />
              <Route path="/posts" element={<Posts />} />
              <Route path="/posts/:slug" element={<PostDetail />} />
            </Routes>
          
          <Footer />
        </div>
      </BrowserRouter>
    </ApolloProvider>
  );
}

export default App;
